module.exports = __webpack_public_path__ + "static/bongxtreme-0245954860269552831e22ea30d9ff36.png";